import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import CampaignDetailContent from '../components/campaign/CampaignDetailContent.vue';
import CampaignSidebar from '../components/campaign/detail-sections/Sidebar.vue'
import MobilePledgeBar from '../components/campaign/detail-sections/MobilePledgeBar.vue'
import PledgeButton from '../components/campaign/PledgeButton.vue'

class CampaignDetailComponent {
  constructor({ container = '#campaign-vue-container', campaignId, campaignMode = 'show' }) {
    this.app = null;
    this.container = container;
    this.campaignId = campaignId;
    this.campaignMode = campaignMode;

    if (!this.campaignId) {
      throw new Error('campaignId is required for CampaignDetailComponent');
    }
  }

  init() {
    const containerElement = this._getContainer();
    if (!containerElement) {
      throw new Error(`Campaign detail container not found: ${this.container}`);
    }

    try {
      this.app = createApp(CampaignDetailContent, {
        campaignId: this.campaignId,
        campaignMode: this.campaignMode
      });

      // 配置插件 - 支援 i18n 和 lazyload
      this.app.use(I18NextVue, { i18next });
      this.app.use(VueLazyload, {
        preLoad: 2.6 // default 1.3
      });

      this.app.component('campaign-sidebar', CampaignSidebar);
      this.app.component('mobile-pledge-bar', MobilePledgeBar);
      this.app.component('pledge-button', PledgeButton);

      this.app.mount(containerElement);
    } catch (error) {
      console.error('Failed to initialize CampaignDetailComponent:', error);
      throw error;
    }
  }

  destroy() {
    if (this.app) {
      try {
        this.app.unmount();
        this.app = null;
      } catch (error) {
        console.error('Failed to destroy CampaignDetailComponent:', error);
      }
    }
  }

  _getContainer() {
    if (typeof this.container === 'string') {
      return document.querySelector(this.container);
    }
    return this.container;
  }
}

export default CampaignDetailComponent;